/*
  STOPGAP — remove when the Conversion Bear Trust Badges app is uninstalled.
  See TURNOVER.md, "Duplicate Secure Checkout With on the PDP".

  That app has no theme extension (0 active); it injects its badge row through
  a store-level ScriptTag from trust.conversionbear.com, so nothing in the
  theme renders it and nothing in the theme editor can remove it. It duplicates
  the theme's own payment row, which is both fuller (8 methods vs 4) and
  accurate, since it reads shop.enabled_payment_types.

  Uninstalling is the real fix but takes effect on the live site immediately,
  so until Brian signs off this hides the app's output on our theme only. The
  script still loads and still costs a request — this only stops it rendering.

  Matching is deliberately narrow: a container the app owns (by id/class), or a
  block whose own text is just a "secure checkout" heading. The theme's own row
  is explicitly excluded so this can never hide the real one.
*/
(function () {
  var OWNED = [
    '[class*="conversionbear" i]',
    '[id*="conversionbear" i]',
    '[class*="conversion-bear" i]',
    '[class*="trust-badge" i]',
    '[id*="trust-badge" i]',
    '[class*="trustbadge" i]',
    '[id*="trustbadge" i]',
  ].join(',');

  function isOurs(el) {
    return !!el.closest('.secure-checkout');
  }

  function hide(el) {
    if (!el || isOurs(el)) return;
    el.style.display = 'none';
    el.setAttribute('data-fm-blocked', 'conversion-bear');
  }

  function sweep() {
    document.querySelectorAll(OWNED).forEach(hide);

    // Fallback for a generically-named container: a small block whose text is
    // just a secure-checkout heading, sitting outside our own badge row.
    document.querySelectorAll('div, section, aside').forEach(function (el) {
      if (el.hasAttribute('data-fm-blocked') || isOurs(el)) return;
      if (el.children.length > 6) return;
      var text = (el.textContent || '').trim();
      if (text.length > 40) return;
      if (!/secure\s+checkout/i.test(text)) return;
      if (el.querySelector('.secure-checkout')) return;
      hide(el);
    });
  }

  function start() {
    sweep();
    var observer = new MutationObserver(sweep);
    observer.observe(document.body, { childList: true, subtree: true });
    // The app injects late; stop watching once it's settled.
    setTimeout(function () {
      observer.disconnect();
      sweep();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
